import React from 'react'
import { Box, Grid } from '@chatterbug/aaron'

export type Props = {
  contentSection?: JSX.Element
  actionsSection?: JSX.Element
}

const PageWrapupSkeleton: React.FC<Props> = ({
  contentSection,
  actionsSection,
}) => {
  return (
    <>
      <Grid columns={1} gap="3x">
        {contentSection}
      </Grid>
      {actionsSection && <Box mt="4x">{actionsSection}</Box>}
    </>
  )
}

export default PageWrapupSkeleton
